import React from 'react';
import {Navigate} from "react-router-dom";
import {checkToken} from "../apiClient/apiClient";

const RouteGuard = ({children, userState, authChecking = false}) => {
    if (authChecking) {
        return null;
    }

    if (
        !checkToken(userState.token_refresh) ||
        !checkToken(userState.token_access)
    ) {
        return <Navigate to="/login" replace/>;
    }
    return children;
}
export default RouteGuard;
